import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';
import { TableCellComponent } from '@captiveaire/table';
import { MessageType } from '@caslink/common-client';
import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';

@Component({
    selector: 'dl-device-status-version-cell',
    templateUrl: './device-status-version-cell.component.html',
    styleUrls: ['./device-status-version-cell.component.scss']
})
export class DeviceStatusVersionCellComponent extends TableCellComponent implements OnInit {
    public static $name: string = 'clDeviceStatusVersionCell';
    @Input() public item: IDeviceStatusListSummary;

    public versionCellFormGroup: FormGroup;
    public versionFormControl: FormControl;

    constructor(private dialogService: DialogService) {
        super();
    }

    get isEditable(): boolean {
        return this.item.$isInEditMode && this.item?.hardwareVersions != null
            && Object.keys(this.item.hardwareVersions).length > 0;
    }

    public ngOnInit() {
        this.versionCellFormGroup = new FormGroup({});
        this.versionFormControl = new FormControl(this.item.hardwareVersion);
        this.versionCellFormGroup.addControl('deviceVersions', this.versionFormControl);
    }

    public updateVersion($event: MatSelectChange) {
        this.item.hardwareVersion = $event.value;
    }

    public showDialog($event) {
        $event.preventDefault();
        $event.stopPropagation();
        const options = {
            data: {
                title: 'Version Mismatch',
                message: 'Change the Template Configuration to match the Embedded Version',
                messageType: MessageType.Warning,
                confirmBtnText: 'OK',
                showCancelBtn: false
            }
        };

        this.dialogService.showConfirmDialog(options);
    }
}
